import React from 'react';
import Countdown from 'react-countdown';

const LineTextCountdown = ({ codeExpirationDate, message, textExpiration }) => {
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span className={'text-s'}>{textExpiration}</span>;
    } else {
      return (
        <span className={'text-s'}>
          {message} {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </span>
      );
    }
  };

  return (
    <Countdown
      date={codeExpirationDate}
      key={codeExpirationDate}
      renderer={renderer}
    />
  );
};

export default LineTextCountdown;
